import $ from 'jquery';

/**
 * jQuery module to convert input text to uppercase while maintaining cursor position
 * Finds all input elements with the "data-uppercase" attribute and adds an input event handler
 */
$(document).ready(function () {
    $(document).on('input', 'input[data-uppercase]', function (e) {
        const cursorPosition = this.selectionStart;
        const currentValue = $(this).val();
        const uppercaseValue = currentValue.toUpperCase();
        if (currentValue !== uppercaseValue) {
            $(this).val(uppercaseValue);
            this.setSelectionRange(cursorPosition, cursorPosition);
        }
    });
});
